/* "We Science'd Underwear" founder video, ported from
   BoxerBriefLifeChangingSection.tsx. Click-to-play facade: the <video> has no
   src until the first tap, so page load costs one lazy poster image only. */

class S1Scienced extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const wrap = this.querySelector('[data-s1-sci-video-wrap]');
    const video = this.querySelector('[data-s1-sci-video]');
    if (!wrap || !video) return;
    const overlay = this.querySelector('[data-s1-sci-overlay]');
    const badge = this.querySelector('[data-s1-sci-badge]');
    const iconPlay = this.querySelector('[data-s1-sci-icon-play]');
    const iconPause = this.querySelector('[data-s1-sci-icon-pause]');

    const setPlaying = (playing) => {
      if (overlay) overlay.classList.toggle('is-playing', playing);
      if (badge) badge.hidden = playing;
      if (iconPlay) iconPlay.hidden = playing;
      if (iconPause) iconPause.hidden = !playing;
    };

    wrap.addEventListener('click', () => {
      if (!video.src) {
        video.src = video.dataset.src;
        video.hidden = false;
      }
      if (video.paused) {
        video.play().catch(() => {});
        setPlaying(true);
      } else {
        video.pause();
        setPlaying(false);
      }
    });

    video.addEventListener('ended', () => setPlaying(false));
  }
}

if (!customElements.get('s1-scienced')) customElements.define('s1-scienced', S1Scienced);
